<script setup>
const _props = defineProps({
  color: {
    type: String,
    default: 'white',
  },
  size: {
    type: String,
    default: 'unset',
  },
})
</script>

<template>
  <div class="IconsWrapper">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.IconsWrapper {
  position: relative;

  height: v-bind(size);
  width: v-bind(size);
  fill: v-bind(color);
  :deep(svg) {
    max-height: v-bind(size);
    max-width: v-bind(size);
    height: 100%;
    width: v-bind(size);

    position: absolute;
    transform: translate(-50%, -50%);
    left: calc(v-bind(size) / 2);
    top: calc(v-bind(size) / 2);
  }
}
</style>
